// FinX legal document content. Rendered verbatim on the /legal page.
// Block types supported by the renderer: "p", "subheading", "bullets", "table", "placeholderLink".
import { PRIVACY_POLICY_DOC } from "./legal/privacyPolicy";
import { TERMS_OF_USE_DOC } from "./legal/termsOfUse";
import { CONSUMER_PRIVACY_NOTICE_DOC } from "./legal/consumerPrivacyNotice";
import { PAYMENT_TERMS_DOC } from "./legal/paymentTerms";
import { CODE_OF_ETHICS_DOC } from "./legal/codeOfEthics";

// Documents referenced within Disclosures that will be provided later.
export const PLACEHOLDER_DOCS = [
  "Form ADV Part 2A Brochure",
  "Client Relationship Summary (Form CRS)",
];

const DISCLOSURES_DOC = {
    id: "disclosures",
    label: "Disclosures",
    title: "Disclosures",
    lastUpdated: "September 28, 2026",
    intro: [],
    sections: [
      {
        heading: "Investment Advisor Disclosure",
        blocks: [
          {
            type: "p",
            text: 'Golden State Tech Inc. doing business as FinX or FinX Stocks (“FinX”) is not currently registered as an investment adviser with the SEC or any state securities authority. Golden State Tech Inc.’s application for registration as an investment adviser with the U.S. Securities and Exchange Commission (“SEC”) is currently pending. (CRD# 344407). Registration does not imply a certain level of skill or training. Advisory services are offered only to clients in jurisdictions where FinX is registered or exempt from registration. More information about FinX is available in its current Form ADV Part 2A Brochure and on the SEC’s Investment Adviser Public Disclosure website.',
          },
          { type: "placeholderLink", label: "Form ADV Part 2A Brochure" },
        ],
      },
      {
        heading: "Client Relationship Summary (Form CRS)",
        blocks: [
          { type: "p", text: "Review the Client Relationship Summary (Form CRS) for more information about FinX and its services." },
          { type: "placeholderLink", label: "Client Relationship Summary (Form CRS)" },
        ],
      },
      {
        heading: "Current Service",
        blocks: [
          { type: "subheading", text: "Free Simulated-Account and Paper-Trading Advice" },
          {
            type: "p",
            text: "Golden State Tech Inc. currently provides automated digital investment advisory recommendations through a free simulated-account or paper-trading environment. Recommendations are generated based on information users submit through the FinX platform’s investment-profile questionnaire. FinX does not charge advisory, subscription, platform-access, or transaction fees for this current service. All portfolio holdings, transactions, account values, and returns displayed within the simulated-account service are hypothetical and do not represent actual client assets, executed securities transactions, or actual investment performance. No actual securities are purchased or sold through this service. FinX does not accept or hold client funds or securities, execute actual trades, or monitor or rebalance users’ actual investment accounts. Simulated results may differ materially from actual investment results and may not reflect fees, taxes, transaction costs, liquidity limitations, or actual market and execution conditions. Simulated performance does not guarantee future results. Before introducing any live-account advisory service or related fees, FinX will provide updated disclosures and obtain applicable client agreements and authorizations.",
          },
        ],
      },
      {
        heading: "Code of Ethics",
        blocks: [
          { type: "p", text: "Review the Code of Ethics (Public Summary) for more information about FinX fiduciary standards." },
          { type: "fileLink", label: "Code of Ethics (Public Summary)", href: "/legal/code-of-ethics-public-summary.pdf" },
        ],
      },
      {
        heading: "Performance & Risk Disclosure",
        blocks: [
          {
            type: "p",
            text: "Past performance does not guarantee future results. Investing involves risk, including the possible loss of principal. FinX’s current service operates in a simulated account or paper-trading environment. Displayed holdings, transactions, account values, and returns are hypothetical and do not represent actual client assets, executed trades, or actual client investment performance. Historical, simulated, hypothetical, backtested, or projected results do not guarantee future performance and may differ materially from actual investment results. Such results may not reflect advisory fees, transaction costs, taxes, bid-ask spreads, liquidity limitations, market impact, or actual execution conditions. Recommendations depend on the accuracy and currency of information users provide and are subject to model, algorithm, and technology risks. FinX does not guarantee returns, preservation of capital, or achievement of any investment objective. Its “Lower Risk,” “Moderate Risk,” and “Higher Risk” labels describe relative model categories; no category is risk-free.",
          },
        ],
      },
      {
        heading: "Brokerage Disclosure",
        blocks: [
          { type: "p", text: "Brokerage services are provided by DriveWealth, LLC, members FINRA/SIPC. For more information, visit www.drivewealth.com or FINRA’s BrokerCheck." },
        ],
      },
      {
        heading: "Third-Party Links",
        blocks: [
          { type: "p", text: "This website may link to third-party websites. These links are provided for informational purposes only. FinX does not endorse nor guarantee the accuracy of information on third-party sites." },
        ],
      },
      {
        heading: "Privacy & Terms",
        blocks: [
          { type: "p", text: "Please review our Privacy Policy and Terms of Use for more information about how we handle your data and the conditions of using this website." },
        ],
      },
    ],
};

export const LEGAL_DOCS = [
  DISCLOSURES_DOC,
  CODE_OF_ETHICS_DOC,
  PRIVACY_POLICY_DOC,
  TERMS_OF_USE_DOC,
  CONSUMER_PRIVACY_NOTICE_DOC,
  PAYMENT_TERMS_DOC,
];
